import { Component, Inject, OnDestroy, OnInit , Input , Output , EventEmitter} from '@angular/core';
import { Store } from '@src/store';
import { projectActions } from "../../../../store/reducers/projectReducer";
import { envTypes } from "../../../../constants/envTypes";


@Component({
    selector: 'env-types',
    template: require('./environmentTypes.html'),
    styles: [require('./_environmentTypes.scss')]
})

export class EnvironmentTypes implements OnInit , OnDestroy {

       @Input() public projectData;
        @Output() public projectdata = new EventEmitter<any>();
        public projectDataDefaults = null;
        public objectsArray:any
        public isLockMainPath = false;
        public _selectedProjectGroup = null;
        public placeHolderProjectGroup :any;
        public unsubscribe:any
        public _selectedTemplateId:any
        public databaseType:any
        public PRE_RUN_ENV_ID:any
        public templates:any


    constructor(@Inject('$scope') public $scope: any, public store : Store, @Inject('$state') public state: any,@Inject('$stateParams') public $stateParams: any) {
        this.databaseType = this.state.params.dbType;
        this.PRE_RUN_ENV_ID = envTypes.PreRun;
    }

    // this.onChangeHost.emit({ hostselected: this.selectedHost,
    //     unmangeSchemasByHostList: this.unmangeSchemasByHostList })

    ngOnInit() { 
        if (this.state.params.continued == null || this.state.params.continued == false){
            this.state.go('app.authorized.projectWizard.settings', { id : this.state.params.id, step : 1 });
        }
        if (this.projectData && this.projectData.dataFlowTyp && this.projectData?.dataFlowType !=null && this._selectedTemplateId != this.projectData.dataFlowType){
            this._selectedTemplateId = this.projectData.dataFlowType;
        }
        this.$scope.$watch(() => this.store.getState().project.environmentTypes, (newVal) => {
            if (newVal == null)
                return;
            if (this._selectedTemplateId != this.projectData?.dataFlowType){
                this.projectData.environmentTypes = newVal;
                let index = this.projectData.environmentTypes.findIndex(x => x.isRMSource === true);
                this.projectData.environmentTypes[index].selected = true;
                let environment  = this.projectData.environmentTypes;
                this.insertToJson('environmentTypes',environment)
                this.insertToJson('dataFlowType',this._selectedTemplateId)
            }
        });

        this.$scope.$watch(() => this.store.getState().project.data, (newVal, oldVal)=>{
            if (newVal == null && oldVal == null)
                return;
            if (this.projectData != null && this.projectData.userInitiatedChange) {
                this._selectedTemplateId = this.projectData.dataFlowType
            }
        });

        this.store.dispatch({ type: projectActions.GET_PROJECT_TEMPLATES, payload: { dbTypeId : this.databaseType } });

        this.unsubscribe = this.store.subscribe(() => {
            if (this.store.getState().project.templates) {
                this.autoClick();
            }
            this.unsubscribe();
        });
    }

    addEnvNo(env) {
        if (env.selected){
            env.quantity += 1;
        }
    }

    decEnvNo(env) {
        if (env.selected && env.quantity > 1) {
            env.quantity -= 1;
        }
    }

    set selectedTemplateId(value) {
        if (value) {
            this._selectedTemplateId = value;
            this.store.dispatch({ type: projectActions.GET_PROJECT_ENV_TYPES, payload: { templateId: value } });
        }
    }

    get selectedTemplateId() {
        return this._selectedTemplateId;
    }

    selectTemplateType(templateId) {
        if (this.selectedTemplateId == templateId) {
            return;
        }
        this.selectedTemplateId = templateId
    }

    public insertToJson(fieldName:string,value,fieldName2 = null,fieldName3 = null){
        if(fieldName2 != null || fieldName3 != null){
            if(fieldName3 != null && this.projectData[fieldName][fieldName2][fieldName3] != undefined){
                 if(this.projectData[fieldName][fieldName2] == undefined){
                    this.projectData[fieldName][fieldName2] = {};
                 }
                this.projectData[fieldName][fieldName2][fieldName3] = value
            }
           else {
            
            this.projectData[fieldName][fieldName2] = value
           }
        }
        else {
            this.projectData[fieldName] = value
        }
        this.projectdata.emit({ fieldName: fieldName , value :value , fieldName2:fieldName2 ,fieldName3:fieldName3 })
     }

    removeEnvsIfUnSelected(envType) {
        if (!envType.selected && envType.environments && envType.environments.length > 0 ) {
            envType.environments = [];
        }
    }

    filterByDbType(data) {
        return data;
    }

    checkNumber(item) {
        if (!item.quantity) {
            item.quantity = 1;
        } else {
            if (item.quantity < 1) {
                item.quantity = 1;
            } else {
                if (item.quantity > 99) {
                    item.quantity = 99;
                }
            }
        }
    }

    autoClick() {}

    ngOnDestroy(): void {}


    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/environmentTypes-ang7/environmentTypes.ts